<script lang="ts">
    import type AnswerEntity from "@apps/reviews/entities/AnswerEntity";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { container } from "tsyringe";

    import MarkedText from "@components/MarkedText.svelte";
    import T from "@components/T.svelte";
    import ViewMore from "@components/ViewMore.svelte";

    export let answer: AnswerEntity;
    export let namespace: string;

    const i18nModule = container.resolve(I18nModule);
    const t_shop_owner$ = i18nModule.exports.i18n.selectT(
        namespace,
        "shop_owner"
    );

    $: customerName = answer.customer?.name ?? $t_shop_owner$;
</script>

<li class="gw-qa-item-answeritem-answer">
    <div class="gw-qa-item-answeritem-answer__header">
        <span class="gw-qa-item-answeritem-answer__username">
            {customerName || answer.shopName}
        </span>
    </div>
    <ViewMore text={answer.body} class="gw-qa-item-answeritem-answer__text">
        <svelte:fragment slot="text">
            <MarkedText text={answer.body} />
        </svelte:fragment>

        <svelte:fragment slot="view_more_text">
            <T {namespace} translationKey="view_more" />
        </svelte:fragment>
        <svelte:fragment slot="view_less_text">
            <T {namespace} translationKey="view_less" />
        </svelte:fragment>
    </ViewMore>
</li>

<style lang="postcss">
    .gw-qa-item-answeritem-answer {
        padding: 1em;
        border-left: 2px solid var(--gw-rv-theme-primaryColor, #8a96a1);
        background-color: var(--gw-rv-review-reply-bg, #fafafa);
        border-radius: 0.25em;

        &__header {
            display: flex;
            flex-direction: column;
            width: fit-content;
            gap: 0.25em;
        }

        &__username {
            font-size: 0.875em;
            text-transform: uppercase;
            font-weight: 600;
            line-height: 16px;
        }

        :global(&__text) {
            margin: 8px 0 0;
            font-size: 0.875em;
        }
    }
</style>
